import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Logo } from "@/components/brand/Logo";
import { NAV } from "@/constants/testIds";
import { NAV_ITEMS } from "./navItems";

export const TopNav = () => (
  <header className="fixed top-0 inset-x-0 z-50 bg-[#0A0B10]/85 backdrop-blur-xl border-b border-white/10">
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
      <Logo />
      <nav className="hidden md:flex items-center gap-1">
        {NAV_ITEMS.map(({ to, label, testId, end }) => (
          <NavLink key={to} to={to} end={end} data-testid={testId}
            className={({ isActive }) => `relative px-4 py-2 text-sm font-semibold tracking-wide transition-colors duration-200 ${isActive ? "text-white after:absolute after:inset-x-4 after:-bottom-[13px] after:h-[2px] after:bg-nw-red" : "text-slate-400 hover:text-white"}`}>
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="flex items-center gap-2">
        <Show when="signed-out">
          <Link to="/sign-in" data-testid={NAV.signIn} className="px-3 py-2 text-sm font-semibold text-slate-300 hover:text-white transition-colors">Sign in</Link>
          <Link to="/sign-up" data-testid={NAV.join} className="btn-red px-4 py-2 text-sm">Join</Link>
        </Show>
        <Show when="signed-in">
          <span data-testid={NAV.userButton}><UserButton /></span>
        </Show>
      </div>
    </div>
  </header>
);
